
// "local"
// export const HostApi = () => {
//   return "http://192.168.29.239:5062";
// };

//Live
// Production API URL
// export const HostApi = () => {
//   return "http://15.135.233.242";
// };
export const HostApi = () => {
  return "https://e-advisorssolution.com";
};